<template>
    <div class="container">
        <nav>
            <ol class="breadcrumb p-1 my-1">
                <span class="ml-auto mr-2 text-muted">{{getMailGroupMember.data.group_members.length}}人</span>
            </ol>
        </nav>
        <div class="card border border-bottom mb-2">
            <ul class="list-group list-group-flush">
                <li class="list-group-item p-2" v-for="item in getMailGroupMember.data.group_members" :key="item.id">
                    <group-row :type="getMailGroupMember.data.group_type" :item="item"></group-row>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import GroupRow from './GroupRow'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            GroupRow
        },
        computed: {
            ...mapGetters(['getMailGroupMember'])
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .opacity0
        opacity: 0
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
